import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { makeUndoCancellationActionProps } from './undo-cancelation-action-props.map';
import { UndoCancellationActionProps, useUndoCancellationAction } from './undo-cancellation-action.hook';

export function UndoCancellationModal({ order, ...rest }: UndoCancellationActionProps) {
  const [state, handlers] = useUndoCancellationAction({ order, ...rest });
  const props = makeUndoCancellationActionProps({
    isLoading: state.loading,
    onCancel: handlers.onCancelIntent,
    onConfirm: handlers.onConfirmUndo,
    errorMessage: state.error ? 'There was an error undoing the cancellation' : undefined
  });

  return <ConfirmationModal {...props} />;
}
